module.exports = __webpack_public_path__ + "resources/send-message-1fcc4bdc5b9dc22adc3bf8c0d5202d2f.svg";